import { PermissionService } from './../services/permission.service';
import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SinglePageGuard implements CanActivate {
	constructor(
		private permissionService: PermissionService,
		private router: Router
	) {}
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.permissionService.isSinglePage()) {
			return true;
		} else {
			this.router.navigate(['']);
			return false;
		}
	}
}
